// extracted by mini-css-extract-plugin
export default {"wrap":"Label_wrap__m79P6","label":"Label_label__nAvOP","value":"Label_value__IdZcD"};